const InMemoryStorage = {
  setItem: (key, value) => {
    InMemoryStorage[key] = value && value.toString();
  },
  getItem: (key) => InMemoryStorage[key],
  removeItem: (key) => {
    delete InMemoryStorage[key];
  },
};

export const setItem = (storages, key, value) => {
  const allStorages = [...storages, InMemoryStorage];

  for (let i = 0; i < allStorages.length; i += 1) {
    try {
      const storage = allStorages[i];
      storage.setItem(key, value);
      break;
    } catch (error) {
      // Ignore the error
    }
  }
};

export const getItem = (storages, key) => {
  const allStorages = [...storages, InMemoryStorage];

  for (let i = 0; i < allStorages.length; i += 1) {
    try {
      const storage = allStorages[i];
      const value = storage.getItem(key);
      if (value !== null) {
        return value;
      }
    } catch (error) {
      // Ignore the error
    }
  }

  return null;
};

export const removeItem = (storages, key) => {
  const allStorages = [...storages, InMemoryStorage];

  for (let i = 0; i < allStorages.length; i += 1) {
    try {
      const storage = allStorages[i];
      storage.removeItem(key);
    } catch (error) {
      // Ignore the error
    }
  }
};
